// eslint-disable-next-line import/no-cycle
// @ts-ignore
import request from 'store/utils/request';

interface ProjectTemplateItem {}

interface ProjectTemplatesListResponse {
  data: {
    count: number;
    results: ProjectTemplateItem[];
  };
}

// eslint-disable-next-line import/prefer-default-export
export const fetchTemplatesRequest = (): Promise<
  ProjectTemplatesListResponse
> => request.get('/project_templates/');
